var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationWrapper',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('b-breadcrumb-item',{attrs:{"to":"/account"}},[_vm._v("Account")]),_c('b-breadcrumb-item',{attrs:{"active":""}},[_vm._v("Invitations")])]},proxy:true}])},[_c('div',{staticClass:"mb-3"},[_c('h1',[_vm._v("Invitations")])]),(_vm.pendingInvitations.length === 0)?_c('b-card',{key:"none",staticClass:"text-center py-5"},[_c('b-card-title',[_vm._v("No Pending Invitations")]),_c('b-card-text',[_vm._v("\n      To join a team, ask a member of the team to invite you\n    ")])],1):_c('b-card',{key:"some",staticClass:"Card-table"},[_c('b-card-text',[_c('b-table',{attrs:{"responsive":"","small":"","fields":[
          {
            key: 'team.name',
            label: 'Team name',
            sortable: true,
          },
          {
            key: 'role.name',
            label: 'Role',
            sortable: true,
          },
          {
            key: 'created_by',
            label: 'Invited by',
            formatter: function formatter(value, key, item) {
              return ("" + (value.name || '@' + value.handle));
            },
            sortable: true,
          },
          {
            key: 'accept',
            label: 'Invite',
            thStyle: { width: '15%' },
          } ],"items":_vm.pendingInvitations},scopedSlots:_vm._u([{key:"cell(accept)",fn:function(data){return [_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.view(data.item.id)}}},[_vm._v("View Invite")])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }